import { Question } from '@n2-common/serverGeneratedTypings/question';

export function filterExtendedQuestions(questions: Question[]) {
    return questions.filter((m) => m.ApplicableForEnhancedDueDiligence);
}

export function getExtendedQuestions(questions: Question[]): string[] {
    const res = filterExtendedQuestions(questions);
    const questionCodes = res.map((m) => m.QuestionCode);
    return questionCodes;
}

export function filterAmlQuestions(questions: Question[], isMainApplicant: boolean | null) {
    return questions.filter((m) => m.ApplicableForAml && (isMainApplicant ? true : m.ApplicableForCoSigner));
}

export function getAmlQuestions(questions: Question[], isMainApplicant: boolean | null): string[] {
    const res = filterAmlQuestions(questions, isMainApplicant);
    const questionCodes = res.map((m) => m.QuestionCode);
    return questionCodes;
}
export function getPepQuestions(questions: Question[]): string[] {
    const res = filterPepQuestions(questions);
    const questionCodes = res.map((m) => m.QuestionCode);
    return questionCodes;
}

export function filterPepQuestions(questions: Question[]) {
    return questions.filter((m) => m.ApplicableForPep);
}

export function getNumericFields(questions: Question[]): string[] {
    const res = questions.filter((m) => m.IsNumeric);
    const questionCodes = res.map((m) => m.QuestionCode);
    return questionCodes;
}

export const isPepFieldName = 'IsPep_Customer';

type Comparrison = {
    questionCode: string;
    compareTo: string;
    message: string;
    validate: (value: string, other: string) => boolean;
};

/**
 * Array of compare validations. If some field validity depends on value from other field.
 */
export const CompareValidation: Comparrison[] = [
    {
        questionCode: 'SecondNationalityCountryCode',
        compareTo: 'NationalityCountryCode',
        message: 'validation:second-nationality.not-same-as-primary',
        validate: (value: string, other: string) => value != other,
    },
];
